export const CApp = {
  Vesion: "2.1.0",
};

export const CRoutePaths = {
  Applications: "/applications",
  Login: "/login",
  ChangePassword: "/change-password",
  MyProfile: "/myprofile",
  Notifications: "/notifications",
  UserControl: "/userControl",
};